// src/components/navigation/LaunchpadButton.js
import React, { useState } from 'react';
import { IconButton, Tooltip } from '@mui/material';
import { Grip } from 'lucide-react';
import Launchpad from './Launchpad';
import { useTranslation } from 'react-i18next';
import { useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';

const LaunchpadButton = ({ onNavigate }) => {
  const [open, setOpen] = useState(false);
  const { t } = useTranslation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <Tooltip title={t('launchpad.title') || 'Launchpad'} arrow>
        <IconButton
          onClick={handleOpen}
          sx={{
            // Blanco en wallpaper, azul en otros
            color: theme.palette.actualMode === 'wallpaper' ? '#FFFFFF' : '#007BFE',
            transition: 'all 0.2s',
            '&:hover': {
              opacity: 0.8,
            },
            width: isMobile ? 28 : 32,
            height: isMobile ? 28 : 32,
            padding: isMobile ? '4px' : '6px',
            marginLeft: isMobile ? '4px' : 0, // Espacio entre botones en móvil
          }}
        >
          <Grip size={isMobile ? 20 : 24} />
        </IconButton>
      </Tooltip>
      
      <Launchpad
        open={open}
        onClose={handleClose}
        onNavigate={onNavigate}
      />
    </>
  );
};

export default LaunchpadButton;